import BorrowerLoans from "./BorrowerLoans.jsx";

export default BorrowerLoans;
